import { takeLatest, put, call } from 'redux-saga/effects';
import * as CommonAction from './action';
import { CORE_API, SCORE_DEFINATION } from '../../config';
import { HTTP_HEADERS } from '../../constants';
import request from '../Utils/httpHelper';


export function* fetchCommentsList(action) {
    let requestUrl = `${CORE_API}/task/comment/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.fetchCommentsSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.fetchCommentsFailure(err))
    }
}
export function* fetchComments() {
    yield takeLatest(CommonAction.FETCH_COMMENTS, fetchCommentsList);
}
export function* postCommentToSection(action) {
    let requestUrl = `${CORE_API}/task/comment/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: action.reqBody, method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonAction.postCommentsSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.postCommentsFailure(err))
    }
}
export function* postComments() {
    yield takeLatest(CommonAction.POST_COMMENTS, postCommentToSection);
}

export function* commentStatus(action) {
    let requestUrl = `${CORE_API}/task/comment/new/count`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(CommonAction.commentReadStatusSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.commentReadStatusFailure(err))
    }
}
export function* commentReadStatus() {
    yield takeLatest(CommonAction.COMMENT_READ_STATUS, commentStatus);
}

export function* aggregateTypes(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/aggregate/types`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.fetchAggregateTypesSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.fetchAggregateTypesFailure(err))
    }
}
export function* fetchAggregateTypes() {
    yield takeLatest(CommonAction.FETCH_AGGREGATE_TYPES, aggregateTypes);
}

export function* aggregateDirections(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/aggregate/directions`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.fetchAggregateDirectionsSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.fetchAggregateDirectionsFailure(err))
    }
}
export function* fetchAggregateDirections() {
    yield takeLatest(CommonAction.FETCH_AGGREGATE_DIRECTIONS, aggregateDirections);
}

export function* dataTypes(action) {
    let requestUrl = `${CORE_API}/creditworthiness/config/datatypes`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.fetchDataTypesSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.fetchDataTypesFailure(err))
    }
}
export function* fetchDataTypes() {
    yield takeLatest(CommonAction.FETCH_DATA_TYPES, dataTypes);
}

export function* fetchRiskcategoryList(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/risklevels`;
    try {
        const riskcategoryList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.fetchRiskgradeCategorySuccess(riskcategoryList.data))
    }
    catch (err) {
        yield put(CommonAction.fetchRiskgradeCategoryFailure(err))
    }
}
export function* fetchRiskcategory() {
    yield takeLatest(CommonAction.FETCH_RISKGRADE_CATEGORY_LIST, fetchRiskcategoryList);
}

export function* getSelectedCountryStates(action) {
    let requestUrl = `${CORE_API}/autocomplete/${action.data}/states`;
    try {
        const stateList = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.getSelectedCountryStatesSuccess(stateList.data))
    }
    catch (err) {
        yield put(CommonAction.getSelectedCountryStatesFailure(err))
    }
}
export function* fetchSelectedCountryState() {
    yield takeLatest(CommonAction.GET_SELECTED_COUNTRY_STATES, getSelectedCountryStates);
}

export function* getCorporateDetails(action) {
    let requestUrl = `${CORE_API}/corporate/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CommonAction.getCoporateDetailsSuccess(result.data));
    } catch (err) {
        yield put(CommonAction.getCoporateDetailsFailure(err))
    }
}
export function* fetchCorporateDetails() {
    yield takeLatest(CommonAction.FETCH_CORPORATE_DETAILS, getCorporateDetails);
}
